<div class="form-panel-preview">
  <div class="header">
    <app-form-section-title [title]="this.fc.Form.title" [isDesigner]="isDesigner" ></app-form-section-title>
  </div>
  <div *ngIf="this.fc.Pages.length > 1" class="my-4">
    <p-steps [model]="pageItems" [activeIndex]="fc.activeIndex"></p-steps>
  </div>
  <div class="content formgrid p-fluid">
    <form #form="ngForm" [formGroup]="fc.FormGroup">
      <ng-container *ngIf="fc.activePage">
        <app-form-section-page [page]="fc.activePage" [pageIndex]="fc.activeIndex"
          [formGroup]="fc.getPageFormGroup(fc.activePage.name)" [isDesigner]="isDesigner">
        </app-form-section-page>
      </ng-container>
    </form>
  </div>
  <div class="footer">

    <p-button *ngIf="!isFirstPage" [label]="'form.button.atras' | translate" (onClick)="prevPage()"
      icon="pi pi-angle-left" styleClass="w-full sm:w-auto" class="w-full sm:w-auto"></p-button>

    <p-button *ngIf="isLastPage && fc.enableSubmit" [label]="'common.continuar' | translate" (onClick)="submit()"
      styleClass="p-button-success w-full sm:w-auto" class="w-full sm:w-auto"></p-button>

    <p-button [label]="'components.app-create-tramite.limpiar-datos' | translate" (onClick)="clearPage()"
      styleClass="p-button-success w-full sm:w-auto" class="w-full sm:w-auto"></p-button>

    <p-button *ngIf="!isLastPage" [label]="'form.button.siguiente' | translate" (onClick)="nextPage()"
      icon="pi pi-angle-right" styleClass="w-full sm:w-auto" class="w-full sm:w-auto"  iconPos="right"></p-button>

  </div>
</div>
